module.exports = __webpack_public_path__ + "resources/img/main10_m.9a54a98eb423bba46966fa770d94b422.png";